import { defineComponent as _defineComponent } from 'vue'
import { TUIGlobal } from "@tencentcloud/chat-uikit-engine";
import { ref, defineEmits, defineProps } from "../../adapter-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
  file: {
    type: String,
    default: "",
  },
  width: {
    type: String,
    default: "20px",
  },
  height: {
    type: String,
    default: "20px",
  },
},
  emits: ["handlerImgClick"],
  setup(__props, { emit: emits }) {

const props = __props


const isApp = ref(TUIGlobal.getPlatform() === "app");

const handlerImgClick = () => {
  emits("handlerImgClick");
};

return { __sfc: true,emits, isApp, props, handlerImgClick }
}

})